<template>
  <div class="text-top">
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-card-title>Add PDF</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid">
            <v-file-input
              label="Add Pdf"
              v-model="serverData.pdf"
              v-bind:rules="validation.pdf"
              accept="application/pdf"
            />
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="serverData.publish_date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  label="Add publish date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind:rules="validation.publish_date"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="serverData.publish_date"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(serverData.publish_date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" color="primary">Cancel</v-btn>
          <v-btn
            text
            color="primary"
            @click="addPdf"
            :loading="isAdding"
            :disabled="!isValid"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as dateFormats from '@/constants/dateFormats'
import pdfApi from '@/api/pdfApi'
import snackbar from '@/utils/snackbar'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    formattedDate () {
      return this.serverData.publish_date
        ? this.$moment(this.serverData.publish_date).format(dateFormats.DDMMYY)
        : ''
    }
  },
  methods: {
    async addPdf () {
      this.$log.info(this.serverData)
      try {
        this.isAdding = true
        const r = await pdfApi.uploadPdf(this.serverData)
        this.$log.info('pdf upload ', [r.data])
        if (r.data === 1) {
          this.$emit('refresh')
          this.$emit('close')
          snackbar.show('PDF uploaded successfully', 'success')
        }
      } finally {
        this.isAdding = false
      }
    }
  },
  data () {
    return {
      menu: null,
      isValid: false,
      isAdding: false,
      serverData: {
        pdf: null,
        publish_date: null
      },
      validation: {
        pdf: [v => !!v || 'Enter PDF first'],
        publish_date: [v => !!v || 'Enter publish date']
      }
    }
  }
}
</script>
